import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export const demoAccountIds = [10, 329, 727, 11479];

export var isDeleted = (obj) => {
	return obj && obj.deleted_at && obj.deleted_at.length > 0;
};

export var rentalStatusClass = (rental) => {
    if (rental && rental.status) {
      var statusClass = "";
      
      switch (rental.status) {
        case "ONMARKET" :
          statusClass = " green";
          break;
        case "APP" :
          statusClass = " orange";
          break;
        case "OFFMARKET" :
          statusClass = " red";
          break;
        default:
          statusClass = "";
          break;
      }

      if (rental.deleted_at)
          statusClass = " completely-black";

      return "rental-status " + statusClass;
    } else {
        return '';
  }
};

export var feeDisplay = (config, fee, feeAdditionalInfo) => {
	if (!config || !config.fee_types)
		return "";

   var feeDisplay = "";
	for (var j = config.fee_types.length - 1; j >= 0; j--) {
		if (config.fee_types[j]["value"] === fee)
         feeDisplay = config.fee_types[j]["name"];
   }
   
   if (feeAdditionalInfo && feeAdditionalInfo.length > 0)
      feeDisplay += ", " + feeAdditionalInfo;

	return feeDisplay;
};

export var petDisplay = (petName, additionalInfo) => {
   if (!petName)
      petName = "";

	if (additionalInfo && additionalInfo.length > 0)
      petName += ", " + additionalInfo;

	return petName;
};

export var laundryDisplay = (config, laundry) => {
	if (!config || !config.laundry_types)
		return "";

	return config.laundry_types[laundry];
}

export var hasRentalSource = (config, source) => {
   return sourceDisplay(config, source).length > 0;
};

export var sourceDisplay = (config, val) => {
	if (!config || !config.rental_sources)
		return "";

	for (var j = config.rental_sources.length - 1; j >= 0; j--) {
		if (config.rental_sources[j]["value"] === val)
			return config.rental_sources[j]["name"];
	}

	return "";
};

export var configName = (options, val) => {
	if (!options || val === undefined || val === null)
		return null;

	for (var j = options.length - 1; j >= 0; j--) {
		if (options[j]["value"] === val || options[j]["value"] === parseFloat(val))
			return options[j]["name"];
	}

	return null;
};

export var configNames = (options, vals) => {
	if (!options || !vals)
		return [];

	var names = [];
	for (var i = 0; i < vals.length; i++) {
		var name = configName(options, vals[i]);
		if (name !== undefined && name !== null)
			names.push(name);
	}

	return names;
};

export var hasMoveInCost = (rental) => {
	if (!rental)
		return false;

   return rental.mic_first_month !== null || rental.mic_last_month !== null 
		|| rental.mic_security !== null || rental.mic_application_fee !== null || rental.mic_move_in_fee !== null
		|| rental.mic_pet_deposit !== null || rental.mic_key_deposit !== null;
};

export var calculateMoveInCost = (rent, moveInCost) => {
	if (moveInCost === "0.25x" || moveInCost === "0.5x" || moveInCost === "1x" || moveInCost === "1.5x" || moveInCost === "2x")
		return rent * parseFloat(moveInCost.replace("x", ""));
	else if (!isNaN(moveInCost))
		return parseFloat(moveInCost);
	else
		return 0;
};

export var isAccountActive = (config) => {
	if (config.is_impersonate)
		return true;
	
	return config.isLoaded && config.account && isActive(config.account.status) && isActive(config.user.status);
}

export var isActive = (status) => {
	if (!status || status.length === 0)
		return false;

	return status === "ACT" || status === "A";
}

export var isDataEntry = (source) => {
	if (!source || source.length === 0)
		return false;

	return source === "Y";
};

export var isInternal = (source) => {
	if (!source || source.length === 0)
		return false;

	return source === 'F';
};

export var isMLS = (source) => {
	if (!source || source.length === 0)
		return false;

	return isMLSPIN(source) || isMRED(source);
}

export var isMLSPIN = (source) => {
	if (!source || source.length === 0)
		return false;

	return source === 'M';
}

export var isMRED = (source) => {
	if (!source || source.length === 0)
		return false;

	return source === 'D';
}

export var isNetwork = (source) => {
	if (!source || source.length === 0)
		return false;

	return source === "S";
};

export var isRentalMLS = (rental) => {
	if (!rental)
		return false;

	return rental.source === "M" || rental.source === "D";
};

export var isOnMarket = (status) => {
	return status === "ONMARKET";
};

export var isPending = (status) => {
	return status === "APP";
};

export var isOffMarket = (status) => {
	return status === "OFFMARKET";
};

export var canManageUserPrivileges = (config) => {
	if (!config.isLoaded)
		return false;

	if (config.account.syndicate.is_share_all)
		return false;

	if (!config.account.is_premium)
		return false;

	return true;
};

export var canShowLandlordInfo = (config) => {
	if (!config || !config.isLoaded)
        return false;
        
    return (!config.account.syndicate.is_share_all || config.account.is_premium) && (config.user.role_landlord_no_search || config.user.role_landlord_full);
};

export var canSearchLandlord = (config) => {
	if (!config || !config.isLoaded)
		return false;
	
	return (!config.account.syndicate.is_share_all || config.account.is_premium) && config.user.role_landlord_full;
};

export var canAccessCreditReports = (config) => {
	if (!config.isLoaded)
      return false;
      
   // if (!config.account.syndicate.is_share_all && !config.account.is_premium)
   //    return false;

	return config.account.tu_subscriber && config.account.tu_subscriber.length > 0 && (canManage(config) || config.user.role_credit_report);
};

export var canUpdate = (config) => {
	if (!config && !config.user)
		return false;
	
	return canManage(config) || config.user.role_update;
}

export var canDelete = (config, obj) => {
	if (!config || !config.user)
		return false;

	if (obj && obj.created_at && obj.created_by === config.user.id) {
		const hours = dateToNow(obj.created_at, 'hours');
		if (hours <= 24)
			return true;
	}

	return canManage(config) || config.user.role_delete;
}

export var canManage = (config) => {
	if (!config || !config.user)
		return false;

	return config.user.role_manager || config.user.role_admin;
}

export var canAdmin = (config) => {
	if (!config || !config.user)
		return false;

	return config.user.role_admin;
}

export var canShare = (config) => {
	if (!config || !config.user || !config.account || !config.account.syndicate)
		return false;

	if (config.account.syndicate.is_share_all)
		return true;
	
	return canManage(config) || config.user.role_share_listing;
}

export var isError = (obj) => {
	if (obj.error) {
		return true;
	} else {
		return false;
	}
};

export var quickDates = () => {
	var dates = [];
	// var year = moment().format("YYYY");
	var now = moment();
	// var septFirst = moment(year + "-09-01").format('MM/DD/YYYY');
	// dates.push(now.isBefore(septFirst) ? septFirst : moment((parseInt(year) + 1) + "-09-01").format('MM/DD/YYYY'));
	// dates.push("");
	for (var i = 0; i < 12; i++) {
		dates.push(moment(now.format("YYYY") + "-" + now.format("MM") + "-01").format('MM/DD/YYYY'));
		dates.push(moment(now.format("YYYY") + "-" + now.format("MM") + "-15").format('MM/DD/YYYY'));	
		now.add(1, 'months');
	}
	
	return dates;
};

export var dateToNow = (date, unit) => {
	var now = moment();
	return moment.range(date, now).diff(unit);
};

export var ageDisplay = (date) => {
	var hours = dateToNow(date, 'hours');
	var minutes = dateToNow(date, 'minutes');
	var dateDisplay = "";

	if (minutes < 1)
		dateDisplay = "Just now";
	else if (minutes < 60)
		dateDisplay = minutes + " minutes ago";
	else if (hours < 24) {
		dateDisplay = hours + " hours ago";
	} else {
		var day = Math.floor(hours / 24);
		dateDisplay = day + " day" + (day > 1 ? "s" : "") + " ago";
	}

	return dateDisplay;
};

export var numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export var checkboxId = (name, value) => {
	if (name === undefined || name === null || value === undefined || value === null)
		return null;

	value = String(value);
	if (value.length === 0)
		return null;
	else
		return "cbx-" + name + value.replace(/[\W_]+/g, '-');
};

export var billingTypeName = (type) => {
    if (type === "ONE")
        return "One-Time";
    else if (type === "REC")
        return "Monthly";
    else if (type === "DIS")
        return "Discount";
    else if (type === "MSG")
        return "Message";
    else
        return "";
};

export var 	getLead = (props) => {
	var {lead, match, config} = props;
	var isIdNumeric = match ? !isNaN(parseInt(match.params.id, 10)) : false;

	if (lead && isIdNumeric && match && match.params && match.params.id && lead.id !== parseInt(match.params.id, 10))
		return null;

	if (isIdNumeric && !config.isLoaded)
		return null;

	if (!lead || !lead.agency_id || (config.isLoaded && lead.agency_id !== config.account.id))
		return null;

	return lead;
};

export var getLandlord = (props) => {
	var {landlord, match, config} = props;
	
	if (landlord && match && match && match.params && match.params.landlordId && landlord.id !== parseInt(match.params.landlordId, 10))
		return null;
	else if (landlord && match && match && match.params && !match.params.landlordId && match.params.id && landlord.id !== parseInt(match.params.id, 10))
		return null;

	if (!config.isLoaded || !landlord || !landlord.syndicate_id || landlord.syndicate_id !== config.account.syndicate_id)
		return null;

	return landlord;
};

export var getRentalGroup = (props) => {
	var {rentalGroup, match, config} = props;
	const params = new URLSearchParams(window.location.search); 
	const listing_group_id = params.get("listing_group_id");

	// if there is already a lead in the state but not the one we want, make sure to display null.
	if (rentalGroup && match && match.params && match.params.id && rentalGroup.id !== parseInt(match.params.id, 10))
		return null;

	if (rentalGroup && listing_group_id && rentalGroup.id !== parseInt(listing_group_id, 10))
		return null;

	if (!config.isLoaded || !rentalGroup || !rentalGroup.owner_id || rentalGroup.owner_id !== config.user.id)
		return null;

	return rentalGroup;
};

export var getRental = (props) => {
   var {rental, match, config} = props;
   var paramId = null;
	if (match && match.params)
		paramId = match.params.rentalId ? match.params.rentalId : (match.params.id ? match.params.id : null);
      
	if (rental && paramId && rental.id !== parseInt(paramId, 10))
		return null;
   
   if (!config.isLoaded || !rental 
      || (isMLS(rental.source) && !config.account.mls_id && !config.user.mls_id && !config.account.is_ygl)
      || (!isMLS(rental.source) && rental.syndicate_id !== config.account.syndicate_id && !config.account.is_ygl))
		return null;

	return rental;
};

export var getSearch = (props) => {
	var {search} = props;

   return search;
};

export var isAccountUpdated = (props, nextProps) => {
	var isUpdated = false;
	if (props.config.isLoaded && nextProps.config.isLoaded) {
		if (props.config.user.id !== nextProps.config.user.id)
			isUpdated = true;
		
		if (props.config.account.updated_at !== nextProps.config.account.updated_at)
			isUpdated = true;

		if (props.config.user.updated_at !== nextProps.config.user.updated_at)
			isUpdated = true;
	}

	return isUpdated;
}


// WEBPACK FOOTER //
// ./src/helpers/configHelper.js